module.exports = __webpack_public_path__ + "PhysicalCropped-f8e821f456580e06f3d2961dcc3f5b8a.png";